
import { mapGetters, mapMutations, mapActions } from 'vuex'
import formValidation from "@/mixins/formValidation";
import filters from "@/mixins/filters";
import offer from "@/apollo/queries/offer/offer"
import jsonld from "@/mixins/jsonld";
import checkboxManagerMixin from '@/mixins/checkboxManager';

export default {
	mixins: [formValidation, filters, jsonld, checkboxManagerMixin],
	props: {
		hasChose: {
			type: Boolean,
			default: true
		},
		offer: Object,
		pageTitle:{
			type: String,
			default: ''
		}
	},
	data() {
		return {
			clientCar: {
				mark: '',
				model: '',
				mileage: ''
			},
			isTraidin: false,
			totalChange: 0,

			creditParams: {
				rangePeriodValues: [
					"2",
					"6",
					"12",
					"24",
					"36"
					// "48",
					// "60",
					// "72",
					// "84"
				],
				rangePaymentValues: [
					'0%',
					'10%',
					'20%',
					'30%',
					'40%',
					'50%',
					'60%',
					'70%',
					'80%',
				],
				period: 36,
				payment: 0,
			}
		}
	},


	async fetch() {
		this.setCurrentCar(null)
		if (Number(this.$route.query.car)) {
			let variables = {
				site_id: this.site_id,
				mark_slug: this.$route.query.mark,
				folder_slug: this.$route.query.model,
				dateFormat: 'j F Y года.',
				external_id: Number(this.$route.query.car)
			}
			let response = await this.request({ query: offer, variables: variables })
			// await this.setOffer(response.data.offer)
			await this.setCurrentCar(response.data.offer)


			await this.sendYandexCommercial()
			await this.sendVkPixel()
		}
	},
	computed: {
		clientCar_mark() {
			return this.clientCar.mark
		},
		clientCar_model() {
			return this.clientCar.model
		},
		clientCar_mileage() {
			return this.clientCar.mileage
		},
		...mapGetters({
			site_id: 'site_id',

			currentCar: 'modal/modal-choose/currentCar',
			bank: 'banks/bank',
			settings: 'settings/settings/settings',
			activeModal: 'modal/modal-main/modal',
			banks: 'banks/banks',
			allMarks: 'marks/marks/allMarks',


		}),
		currentCarPrice() {
			let newCurrentCarPrice = String(this.currentCar.price).split('')
			newCurrentCarPrice.splice(-3, 0, ' ')
			newCurrentCarPrice.length > 6 && newCurrentCarPrice.splice(-7, 0, ' ')
			return newCurrentCarPrice.join('')
		},
		percent() {
			// Динамично меняет процентную ставку в зависимости от банка
			// return this.bank.rate ? this.bank.rate : this.$config.default_percent
			return this.$config.default_percent
		},
		formProgress() {
			let progress = 30
			if (this.currentCar || this.offer) {
				progress += 30
			}
			if (this.name_valid) {
				progress += 10
			}
			if (this.date_valid) {
				progress += 10
			}
			if (this.phone_valid) {
				progress += 10
			}
			if (this.form.agree) {
				progress += 4
			}
			if (this.form.agreeRf) {
				progress += 4
			}
			return progress
		},
		currentDealer() {
			if (this.offer) {
				return this.offer.dealer
			} else if (this.currentCar) {
				return this.currentCar.dealer
			}
		},
		marksLength() {
			return this.allMarks ? this.allMarks.reduce((prev, next) => prev += next.offers_count, 0) : ''
		},
	},
	methods: {
		onFocus() {
			this.setFocusShowFixes(false)
		},
		onFocusOut() {
			setTimeout(() => {
				this.setFocusShowFixes(true)
			}, 1000)
		},
		...mapActions({
			openModal: 'modal/modal-main/openModal',
			closeModal: 'modal/modal-main/closeModal',
			sendForm: 'form/form/sendForm',
			request: 'filters/filters/request',

		}),
		...mapMutations({
			setPercent: 'banks/SET_PERCENT',
			// setCurrentCar: 'form/form-credit/SET_CURRENT_CAR',
			setFocusShowFixes: 'car/car/SET_FOCUS_SHOW_FIXED',
			setOffer: 'catalog/catalog-cars/SET_OFFER',
			setCurrentCar: 'modal/modal-choose/SET_CURRENT_CAR',



		}),
		choseCar() {
			this.error = ''
			let payload = {
				modal_component: 'modal-choose',
				modal_title: 'Выберите автомобиль',
				modal_sub_title: `${this.marksLength} автомобилей в наличии`
			}
			this.openModal(payload)
		},
		dateMaskComplete() {
			let nowDate = Number(new Date().getFullYear()) - 18;
			if (Number(this.form.date.value.split('/')[0]) > 32 || Number(this.form.date.value.split('/')[1]) > 12
				|| Number(this.form.date.value.split('/')[2]) > nowDate || Number(this.form.date.value.split('/')[2]) < 1900) {
				this.form.date.valid = false
			}
			else { this.form.date.valid = true }
		},
		checkForm() {
			if (this.hasChose) {
				if (!this.currentCar) {
					this.error = 'invalid_car'
					this.universalScroll('form--universal', 'form--universal')
					return false
				}
			}
			if (this.isTraidin) {
				if (this.form.car.value.length < 2) {
					if (this.form.mark.value.length < 2) {
						this.form.mark.valid = false
						this.universalScroll('textWithCheckbox', 'textWithCheckbox')
						return false
					}
					if (this.form.model.value.length < 1) {
						this.form.model.valid = false
						this.universalScroll('textWithCheckbox', 'textWithCheckbox')
						return false
					}
					if (this.form.run.value.length < 2) {
						this.form.run.valid = false
						this.universalScroll('textWithCheckbox', 'textWithCheckbox')
						return false
					}
				}

			}
			if (this.form.name.value.length < 2) {
				this.form.name.valid = false
				this.universalScroll('textWithCheckbox', 'textWithCheckbox')
				return false
			}
			// if (this.form.date.value === '' || this.form.date.value.split('_').length > 1) {
			// 	this.form.date.valid = false
			// 	this.universalScroll('textWithCheckbox', 'textWithCheckbox')
			// 	return false
			// }
			// let nowDate = Number(new Date().getFullYear()) - 18;
			// if (Number(this.form.date.value.split('/')[0]) > 32 || Number(this.form.date.value.split('/')[1]) > 12
			// 	|| Number(this.form.date.value.split('/')[2]) > nowDate || Number(this.form.date.value.split('/')[2]) < 1900) {
			// 	this.form.date.valid = false
			// 	this.universalScroll('textWithCheckbox', 'textWithCheckbox')
			// 	return false
			// }
			if (!this.form.phone.valid) {
				this.form.phone.valid = false
				this.universalScroll('textWithCheckbox', 'textWithCheckbox')
				return false
			}
			const checkboxesValid = this.validateCheckboxes();
      if (!checkboxesValid) {
        return false;
      }
			return true;
		},
		async submitForm() {
			if (this.checkForm()) {

				let formData = {
					chosen_car: this.currentCar || this.offer, //нужно для страницы thanks
					external_id: this.hasChose ? this.currentCar.external_id : this.offer.external_id,
					type: 'hire-purchase',
					dealer: this.currentDealer.slug,
					client_name: this.form.name.value,
					client_phone: this.form.phone.value,
					client_age: this.form.date.value,
					credit_initial_fee: this.form.paymentValue.toString(),
					credit_period: this.form.periodValue.toString() + " мес.",
				}

				if (this.isTraidin)
					formData.client_vehicle_mark = this.form.mark.value + '/' + this.form.model.value + '/' + this.form.run.value
				// utm
				if (localStorage.utm_source) {
					formData.utm_source = localStorage.utm_source
				}
				if (localStorage.utm_medium) {
					formData.utm_medium = localStorage.utm_medium
				}
				if (localStorage.utm_campaign) {
					formData.utm_campaign = localStorage.utm_campaign
				}
				if (localStorage.utm_term) {
					formData.utm_term = localStorage.utm_term
				}
				if (localStorage.utm_content) {
					formData.utm_content = localStorage.utm_content
				}

				await this.sendForm(formData)
				await this.closeModal()
			}
		},
		universalScroll(mob, deck) {
			setTimeout(() => {
				if (this.$device.isMobile) {
					const target = document.body.getElementsByClassName(mob)[0]
					window.scrollBy({
						top: target.getBoundingClientRect().top - 60,
						left: 0,
						behavior: 'smooth'
					})
				} else {
					const target = document.body.getElementsByClassName(deck)[0]
					window.scrollBy({
						top: target.getBoundingClientRect().top - 120,
						left: 0,
						behavior: 'smooth'
					})
				}

			})
		}
	},
	watch: {
		clientCar_mark(value) {
			this.form.car.value = value + '/' + this.clientCar_model + '/' + this.clientCar_mileage
		},
		clientCar_model(value) {
			this.form.car.value = this.clientCar_mark + '/' + value + '/' + this.clientCar_mileage
		},
		clientCar_mileage(value) {
			this.form.car.value = this.clientCar_model + '/' + value + '/' + value
		},
		currentCar() {
			this.universalScroll('catalog__images--for-mobile', 'form-credit')

		}

	},
	mounted() {
		if (document)
			this.anchor = document.getElementsByClassName('desc accent bold')[0].getBoundingClientRect().y - 166

		// if (this.$route.query['mark']) setTimeout(function () {
		// 	if (window.innerWidth <= 800) {
		// 		const fc = document.getElementsByClassName('form-credit')[0]
		// 		const fc_top = fc.getBoundingClientRect().top

		// 		window.scrollTo({
		// 			top: fc_top - 100,
		// 			left: 0
		// 		})
		// 	} else {
		// 		const bs = document.getElementsByClassName('swiper--benefits')[0]
		// 		const bs_top = bs.getBoundingClientRect().top

		// 		window.scrollTo({
		// 			top: bs_top,
		// 			left: 0
		// 		})
		// 	}
		// }, 100)
	}


}
